import React, { useEffect, useState } from "react";
import ComissionCalculator from "../ComissionCalculator/ComissionCalculator";
import ComissionCalculatorResult from "../ComissionCalculatorResult";
import ComissionQuote from "../ComissionQuote/ComissionQuote";

const CalculatorQuoteGenerator = () => {
  const [calc, setCalc] = useState(true);
  const [calcIndividual, setCalcIndividual] = useState(true);
  const [price, setPrice] = useState(300000)
  const [dueDiligenceTimeline, setDueDiligenceTimeline] = useState('3-4 weeks')
  const [checkboxState, setCheckboxState] = useState({
    pv: true,
    lvp: true,
    tsa: false,
    qoe: false,
    df: false,
  });

  return (
    <>
      <div>
        {" "}
        <img src="./rapid-diligence-logo-transparent.png" width={300} alt="" />
      </div>
      {calcIndividual ? (
        <>
          <div>
            {calc ? (
              <ComissionCalculator
                setPrice={setPrice}
                dueDiligenceTimeline={dueDiligenceTimeline}
                setDueDiligenceTimeline={setDueDiligenceTimeline}
                setCalc={setCalc}
                setCalcIndividual={setCalcIndividual}
                price={price}
                setCheckboxState={setCheckboxState}
                checkboxState={checkboxState}
              />
            ) : (
              <ComissionQuote
                price={price}
                dueDiligenceTimeline={dueDiligenceTimeline}
                setCalc={setCalc}
              />
            )}
          </div>
        </>
      ) : (
        <>
          <div>
            {calc ? (
              <ComissionCalculator
                setPrice={setPrice}
                setDueDiligenceTimeline={setDueDiligenceTimeline}
                setCalc={setCalc}
                setCalcIndividual={setCalcIndividual}
                price={price}
                setCheckboxState={setCheckboxState}
                checkboxState={checkboxState}
              />
            ) : (
              <ComissionCalculatorResult
                price={price}
                dueDiligenceTimeline={dueDiligenceTimeline}
                setCalc={setCalc}
                checkboxState={checkboxState}
              />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default CalculatorQuoteGenerator;
